export default __webpack_public_path__ + "static/media/home.3b12f254.svg";